import { render, staticRenderFns } from "./ModifyContact.vue?vue&type=template&id=17be25ae&scoped=true&"
import script from "./ModifyContact.vue?vue&type=script&lang=js&"
export * from "./ModifyContact.vue?vue&type=script&lang=js&"
import style0 from "./ModifyContact.vue?vue&type=style&index=0&id=17be25ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be25ae",
  null
  
)

export default component.exports